import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

export interface Payload {
  email: string;
  firstName: string;
  lastName: string;
}
  
export function useUserNewOrganisationUserMutation() {
  const queryClient = useQueryClient();
  const { keycloak } = useKeycloak();

  return useMutation({
    mutationFn: async (payload: Payload): Promise<object> => {
      const response = await fetch(
        `${import.meta.env.VITE_USER_ENGINE_ENDPOINT}/api/v1/bundles/user_bundle/functions/create_organisation_user`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`
          },
          method: 'POST',
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      if (!response.ok || (typeof data.code === 'number' && data.code >= 400)) {
        throw new Error(data.message || 'Failed to create organisation user');
      }

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['userOrganisationUsers']);
    }
  });
}